export const propertyMap = {
    requestId: 'REQUEST_ID',
    reqType: 'REQ_TYPE',
    reqRole: 'REQ_ROLE',
    status: 'STATUS',
    approverComments: 'APPROVER_COMMENTS',
    createdAt: 'CREATED_AT',
  };
  